// Copyright (c) Microgreen Manager LLC. All rights reserved. Proprietary and confidential. Unauthorized copying is strictly prohibited.
// import { Logo } from '../logo';
import { styled } from '@mui/material/styles';
// biome-ignore lint/style/useImportType: <explanation>
import * as React from 'react';
import { CircularProgress } from '../../../lib/base';

const StyledDiv = styled('div', { shouldForwardProp: (prop) => prop !== 'disablePadding' })<{
  readonly disablePadding?: boolean;
}>(({ theme, disablePadding }) => ({
  [theme.breakpoints.down('md')]: {
    paddingTop: disablePadding ? undefined : theme.spacing(2),
    paddingBottom: disablePadding ? undefined : theme.spacing(2),
  },
  [theme.breakpoints.up('md')]: {
    paddingTop: disablePadding ? undefined : theme.spacing(3),
    paddingBottom: disablePadding ? undefined : theme.spacing(3),
  },
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
}));

interface Props {
  disablePadding?: boolean;
}
function PageLoading({ disablePadding }: Props): React.ReactElement {
  return (
    <StyledDiv disablePadding={disablePadding}>
      <CircularProgress color="secondary" size={32} />
      {/* <Logo width={48} height={56} /> */}
      {/* <LinearProgress sx={{ mt: 2, width: (t) => t.spacing(16) }} /> */}
    </StyledDiv>
  );
}

export default PageLoading;
